const contactAnim = {
  isMobileOrTablet() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || navigator.maxTouchPoints > 2
    );
  },

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const cursor = document.querySelector(".blob-agence");
      const user = "contact";
      const domain = "agencetaurine.fr";

      document.querySelector(".email").innerHTML = user + "@" + domain;
      
      document.querySelector(".email").addEventListener('click', () => {
        window.location.href = "mailto:" + user + "@" + domain;
      })


      /* GSAP ANIMATIONS */
      //Smooth content
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.7,
        effects: false,
      });

      // N'appliquer les effets du curseur que si ce n'est pas un mobile/tablette
      if (!this.isMobileOrTablet()) {
        // 2. Suivi de la souris avec throttle à 60fps (~16.67ms)
        const root = document.documentElement;
        const smoothContent = document.querySelector("#smooth-content");
        let mx = -9999,
          my = -9999,
          rafId = 0,
          lastUpdateTime = 0;
        const THROTTLE_INTERVAL = 1000 / 60; // ~16.67ms pour 60fps

        function apply() {
          // Mettre à jour les variables CSS pour tous les éléments .glow-border
          const glowBorders = document.querySelectorAll(".glow-border");

          glowBorders.forEach((element) => {
            element.style.setProperty(
              "--mx",
              mx - element.getBoundingClientRect().left,
            );
            element.style.setProperty(
              "--my",
              my - element.getBoundingClientRect().top,
            );
          });

          // Mettre à jour le cursor blob avec les coordonnées correctes
          if (cursor) {
            // Récupérer le décalage Y du smooth-content
            const scrollOffset = gsap.getProperty("#smooth-content", "y") || 0;
            gsap.to(cursor, {
              x: mx - 25,
              y: my - 25 - scrollOffset,
              duration: 0,
              overwrite: false,
            });
          }

          rafId = 0;
          lastUpdateTime = performance.now();
        }

        function move(e) {
          // Utilise les coordonnées de la souris par rapport au viewport
          mx = e.clientX;
          my = e.clientY;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        function leave() {
          mx = -9999;
          my = -9999;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        // Écoute sur window pour éviter les problèmes de capture d'événements
        window.addEventListener("pointermove", move, { passive: true });
        window.addEventListener("pointerleave", leave, { passive: true });
      }

      //
      //
      //Scramble text
      //
      //
      let scrambles = document.querySelectorAll(".scramble");

      scrambles.forEach((scramble) => {
        gsap.to(scramble, {
          scrollTrigger: {
            trigger: scramble,
            start: "-100px 80%",
          },
          scrambleText: {
            rightToLeft: true,
            chars: "upperCase",
          },
          duration: 1,
        });
      });

      // SCROLL TO TOP BUTTON
      const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      }

      // LIENS ANCRES

      // après avoir initialisé ScrollSmoother
      /* if (window.location.hash) {
        const id = window.location.hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          const smoother = ScrollSmoother.get();
          if (smoother) {
            smoother.scrollTo(target, true, "top top");
          } else {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }

      let heroBtn = document.querySelector(".hero-btn");
      heroBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let target = document.querySelector(heroBtn.getAttribute("href"));
        ScrollSmoother.get().scrollTo(target, true, "center center");
      });

      // Sélectionne tous les liens dans le menu et le footer
      const checkSmoother = setInterval(() => {
        if (typeof ScrollSmoother !== "undefined" && ScrollSmoother.get()) {
          clearInterval(checkSmoother);

          // Sélectionne tous les liens dans le menu et le footer
          const menuLinks = document.querySelectorAll(
            '.topmenu-container a[href*="#"], footer a[href*="#"]',
          );
          menuLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
              // only intercept links that point to an anchor on the *current* page
              const href = this.getAttribute("href");
              if (!href) return;

              // build a URL to compare pathnames even when href is relative
              const url = new URL(href, window.location.origin);
              if (url.pathname !== window.location.pathname) {
                // different page, allow normal navigation
                return;
              }

              e.preventDefault();

              // extract the anchor id and scroll to it
              const targetId = url.hash.replace("#", "");
              if (!targetId) return;

              const target = document.getElementById(targetId);
              if (!target) return;

              const smoother = ScrollSmoother.get();
              if (smoother) {
                smoother.scrollTo("#" + targetId, true, "top top");
              } else {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            });
          });
        }
      }, 100); // Vérifie toutes les 100ms */

      // Skills Accordion for Mobile
      const skillNames = document.querySelectorAll(".skill-name");
      const skills = document.querySelectorAll(".skill");

      skillNames.forEach((skillName) => {
        skillName.addEventListener("click", (e) => {
          const skill = skillName.closest(".skill");
          const isActive = skill.classList.contains("active");

          // Close all skills
          skills.forEach((s) => s.classList.remove("active"));

          // Toggle current skill
          if (!isActive) {
            skill.classList.add("active");
          }
        });
      });

      // Project List Drag Functionality
      const projectList = document.querySelector(".project-list");
      if (projectList) {
        let isDown = false;
        let startX;
        let scrollLeft;

        projectList.addEventListener("mousedown", (e) => {
          isDown = true;
          projectList.style.cursor = "grabbing";
          startX = e.pageX - projectList.offsetLeft;
          scrollLeft = projectList.scrollLeft;
          e.preventDefault();
          e.stopPropagation();
        });

        projectList.addEventListener("mouseleave", () => {
          isDown = false;
          projectList.style.cursor = "grab";
        });

        projectList.addEventListener("mouseup", () => {
          isDown = false;
          projectList.style.cursor = "grab";
        });

        projectList.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          e.stopPropagation();
          const x = e.pageX - projectList.offsetLeft;
          const walk = (x - startX) * 1;
          projectList.scrollLeft = scrollLeft - walk;
        });
      }
    });
  },
};

export default contactAnim;
